// inspired by, https://github.com/developit/mitt/blob/main/src/index.ts
// which is recommended by the Vue 3 doc.

const globalHandler = {};

export const emit = (handler) => (key, ...args) => {
  if (typeof handler[key] === 'undefined') {
    return;
  }
  for (let i = 0; i < handler[key].length; i++) {
    handler[key][i](...args);
  }
};

export const on = (handler) => (key, fn) => {
  if (typeof handler[key] === 'undefined') {
    handler[key] = [fn];
  }
  for (let i = 0; i < handler[key].length; i++) {
    if (handler[key][i] === fn) {
      return;
    }
  }
  handler[key].push(fn);
};

export const off = (handler) => (key, fn) => {
  if (typeof handler[key] === 'undefined') {
    return;
  }

  for (let i = 0; i < handler[key].length; i++) {
    if (handler[key][i] === fn) {
      handler[key].splice(i, 1);
    }
  }
};

export const EventBus = {
  $emit: emit(globalHandler),
  $on: on(globalHandler),
  $off: off(globalHandler),
};
